import { gql } from '@biletiniz/apollo';

export const CHECK_SERVER_STATUS = gql`
  query checkServerStatus {
    checkServerStatus {
      isWorking
      registerADsWorking
    }
  }
`;
